import React from 'react';
import {ScrollPanel} from "primereact/scrollpanel";
import {OverlayPanel} from "primereact/overlaypanel";
import moment from 'moment';
import {formatTimeStamp} from "../actions/commonActions";
import handleDateSelect from '../../helper/convertDateIntoPSTFormat';

const statusDot = (status) => {

    if (status === 'Pending' || status === 'Open' || status === 'Pending Acknowledged' || status === 'Pending Approval' ) {
        return <i className='gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]'></i>;
    }

    if (status === 'Approved' || status === 'Acknowledge') {
        return <i className='gusd-dot text-[16px] xl:text-[0.833vw] text-[#22c55e]'></i>;
    }

    if (status === 'Rejected') {
        return <i className='gusd-dot text-[16px] xl:text-[0.833vw] text-[#d9342b]'></i>;
    }

}

const notificationTile = (notificationData, index) => {
    const {notificationTitle ,notificationMessage, notificationDate} = notificationData;
    return (
     <div key={index} className='col py-[18px] xl:py-[0.625vw]'>
        <div className='flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]'>
            <div className='flex items-start space-x-[10px] xl:space-x-[0.521vw]'>
                {/*<div><i className='gusd-chat text-[18px] xl:text-[1.042vw] text-[#667085]'></i></div>*/}
                <div className='content'>
                    <div className='text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold'>{notificationTitle}
                    </div>
                    <div className='pt-1 text-[14px] xl:text-[0.729vw] text-[#344054]'>
                        
                    <div dangerouslySetInnerHTML={{ __html: notificationMessage }}></div>
                    
                    </div>
                    <div className='pt-1 text-[#667085] text-[12px] xl:text-[0.625vw]'>{
                        handleDateSelect(notificationDate)}</div>
                </div>
            </div>

            <div className='dot'>
                {statusDot(notificationTitle)}
            </div>

        </div>
    </div>
    )
}

const NotificationComponent = ({notificationRef, notifications}) => {

    return (
     <OverlayPanel ref={notificationRef} showCloseIcon className='notification'>
         <div
          className='text-[#344054] font-semibold text-[18px] xl:text-[0.938vw] mb-[8px] xl:mb-[0.417vw]'>Notifications
         </div>
         <ScrollPanel style={{width: '100%', height: '23.438vw'}} className="custombar1">
             <div className='grid grid-cols-1 divide-y'>
                 {
                     notifications.map((notification, index) => notificationTile(notification, index))
                 }
             </div>
         </ScrollPanel>
     </OverlayPanel>
    )
}

export default NotificationComponent;